@if (loaderRouterEventService.isLoading()) {
  <app-loader></app-loader>
} @else {
  <router-outlet></router-outlet>
}
@if (loaderInitialService.isLoading()) {
  <app-loader-astronaut></app-loader-astronaut>
}
